var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center footer"},[_c('br'),_c('label',{staticClass:"cobertura"},[_vm._v("El riesgo de este seguro es cubierto por ")]),_c('div',{staticClass:"text-center"},[_c('v-img',{staticStyle:{"margin":"auto"},attrs:{"contain":"","max-height":"70px","src":_vm.LogoSB,"max-width":"170"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }